export default __webpack_public_path__ + "static/media/wrong-sound.21431d09.mp3";